import type mapboxgl from "mapbox-gl"

export type MapControlPosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"

/**
 * Mirror of Mapbox GL JS IControl.
 * Controls implementing this interface can be added to <trip-map> or
 * <globe-view> via addControl() or as declarative child elements.
 */
export interface MapControl {
  onAdd(map: mapboxgl.Map): HTMLElement
  onRemove(map: mapboxgl.Map): void
  position?: MapControlPosition
}

export function isMapControl(el: Element): el is Element & MapControl {
  return typeof (el as unknown as MapControl).onAdd === "function" &&
    typeof (el as unknown as MapControl).onRemove === "function"
}
